import { StcLogo } from "./brand-logo";

export function StcFooterLogo({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`stc-footer-logo${compact ? " compact" : ""}`}>
      <StcLogo />
      <span>SPAM THE CHAIN</span>
    </span>
  );
}
